import React from 'react';
import ChooseAccountsStep from 'components/AccountConnectionFlow/ChooseAccountsStep';

const ActivateTiktokAccountsStep = (props) => {
  return <ChooseAccountsStep />;
};

export default ActivateTiktokAccountsStep;
